import { call, put, takeLatest } from "redux-saga/effects";
import API from "us.common/services";
import { Entity } from "us.common/constants/Entity";
import * as Action from "us.common/actions";
import _ from "lodash";
import { $MessageBox } from "us.common/components";

const { entity } = Action;

const entitySagas = {
  get: function* (action: any): Generator<any, void, any> {
    const params = action.payload;
    try {
      const data = yield call(API.entityDetails.getEntityDetail, params);
      if (data && data?.statusCode != 400) {
        yield put(entity.getSuccess(data));
      } else {
        yield put(entity.getFail({}));
      }
    } catch (error) {
      yield put(entity.getFail({}));
    }
  },
  getPostalAreas: function* (action: any): Generator<any, void, any> {
    const params = action.payload?.data;
    try {
      const data = yield call(API.entityDetails.getPostelArea, params);
      if (Array.isArray(data)) {
        yield put(entity.getPostalAreasSuccess(data));
      } else {
        yield put(entity.getPostalAreasFail([]));
      }
    } catch (error) {
      yield put(entity.getPostalAreasFail([]));
    }
  },
  getPostalCountries: function* (): Generator<any, void, any> {
    try {
      const { data, status } = yield call(API.entityDetails.getCountries);
      if (status == 200) {
        yield put(entity.countries.success(data));
      } else {
        yield put(entity.countries.fail([]));
      }
    } catch (error) {
      yield put(entity.countries.fail([]));
    }
  },
  getMunicipals: function* (action: any): Generator<any, void, any> {
    const params = action.payload.data;
    try {
      const data = yield call(API.entityDetails.getMunicipals, params);
      if (data.errors) {
        yield put(entity.getMunicipalsFail([]));
      } else if (Array.isArray(data)) {
        yield put(entity.getMunicipalsSuccess(data));
      } else {
        yield put(entity.getMunicipalsFail([]));
      }
    } catch (error) {
      yield put(entity.getMunicipalsFail([]));
    }
  },
  addPostalArea: function* (action: any): Generator<any, void, any> {
    const params = action.payload.data;
    const { saveParams } = params ?? {};
    const { postalCodeId, countryCode } = saveParams ?? {};
    try {
      const data = yield call(API.entityDetails.addPostalArea, saveParams);
      if (data?.hasOwnProperty("postalCodeId")) {
        yield put(entity.addPostalAreaSuccess(data));
        const postalCodes = yield call(API.entityDetails.getPostelArea, {
          countryCode: countryCode ?? "",
          searchText: "",
        });
        if (Array.isArray(postalCodes)) {
          yield put(entity.getPostalAreasSuccess(postalCodes));
        } else {
          yield put(entity.getPostalAreasFail([]));
        }
        if (postalCodeId > 0) {
          $MessageBox(
            "success",
            "US.COLLECTION.COMMON:ENTITYSELECTION.SUCCESSFULLY_UPDATED",
            "",
            ""
          );
        } else {
          $MessageBox(
            "success",
            "US.COLLECTION.COMMON:ENTITYSELECTION.SUCCESSFULLY_ADDED",
            "",
            ""
          );
        }
      } else if (data?.message?.includes("postalCode is Already Exists")) {
        yield put(entity.addPostalAreaFail({}));
        $MessageBox(
          "error",
          "US.COLLECTION.COMMON:ENTITYSELECTION.POSTALCODE_IS_ALREADY_EXIXTS",
          "",
          ""
        );
      } else {
        yield put(entity.addPostalAreaFail({}));
        if (postalCodeId > 0) {
          $MessageBox(
            "error",
            "US.COLLECTION.COMMON:ENTITYSELECTION.POSTALCODE_UPDATE_FAIL",
            "",
            ""
          );
        } else {
          $MessageBox(
            "error",
            "US.COLLECTION.COMMON:ENTITYSELECTION.POSTALCODE_REGISTRATION_FAIL",
            "",
            ""
          );
        }
      }
    } catch (error) {
      yield put(entity.addPostalAreaFail(error));
    }
  },
  postalcodeAvailability: {
    get: function* (action: any): Generator<any, void, any> {
      const params = action.payload?.data;
      try {
        const data = yield call(API.entityDetails.getPostelArea, params);
        if (!_.isEmpty(data)) {
          yield put(entity.postalCodeAvailability.success(data));
        } else {
          yield put(entity.postalCodeAvailability.fail({}));
        }
      } catch (error) {
        yield put(entity.postalCodeAvailability.fail(error));
      }
    },
  },
};

export default [
  takeLatest(Entity.GET_ENTITY_DETAIL_START, entitySagas.get),
  takeLatest(Entity.GET_POSTAL_AREAS, entitySagas.getPostalAreas),
  takeLatest(Entity.GET_MUNICIPALS, entitySagas.getMunicipals),
  takeLatest(Entity.ADD_POSTAL_AREAS, entitySagas.addPostalArea),
  takeLatest(Entity.GET_POSTAL_COUNTRIES, entitySagas.getPostalCountries),
  takeLatest(
    Entity.GET_POSTAL_CODE_AVAILABILITY_START,
    entitySagas.postalcodeAvailability.get
  ),
];
